<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Transaction Date Validity Rule"
      text="Edit Claim Transaction Date Validity Rule"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localClaimTransactionDateValidityRule.start_day"
                v-validate="'required|min_value:0'"
                :min="0"
                :error-messages="errors.collect('start_day')"
                type="number"
                data-vv-name="start_day"                
                label="Start Day"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="localClaimTransactionDateValidityRule.end_day"
                v-validate="'required|min_value:0'"
                :min="0"
                :error-messages="errors.collect('end_day')"
                type="number"
                data-vv-name="end_day"                
                label="End Day"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>
          
            <v-col
              cols="12"
              class="pt-2"
            >
              <span> Requires remark? </span>
              <v-radio-group
                v-model="localClaimTransactionDateValidityRule.requires_remark"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              cols="12"
              class="pt-2"
            >
              <span> Requires additional approver? </span>
              <v-radio-group
                v-model="localClaimTransactionDateValidityRule.requires_additional_approver"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      claimTransactionDateValidityRule: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localClaimTransactionDateValidityRule: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        
        this.localClaimTransactionDateValidityRule = { ...this.claimTransactionDateValidityRule }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
        
            this.progressing = true

            this.$api.claimTransactionDateValidityRules().update(this.localClaimTransactionDateValidityRule.id, this.prepareFormData())
              .then(res => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('updated')              
                  this.$snack({ message: 'Rule updated' })
                  this.$resetData()
                  this.dialog = false                 
                }
              })
              .catch(() => {
                this.$snack({
                  color: 'error',
                  message: 'Failed to update rule',
                })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          start_day: this.localClaimTransactionDateValidityRule.start_day,
          end_day: this.localClaimTransactionDateValidityRule.end_day,
          requires_remark: this.localClaimTransactionDateValidityRule.requires_remark,
          requires_additional_approver: this.localClaimTransactionDateValidityRule.requires_additional_approver,
        }
      },
    },
  }
</script>
